import React from 'react';
import Header from './Header';
import Footer from './Footer';
import BackToTopButton from './BackToTopButton';
import { Container } from 'react-bootstrap';

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Container className='mt-5'>
        {children}
      </Container>
      <Footer />
      <BackToTopButton />
    </>
  );
}

export default Layout;